import React, { Component } from 'react';
import MessageIcon from '../../images/msg-envelope.png';
import { Text } from '@app-masters/react-lib';

class EmailView extends Component {
    optionsRenderer () {
        let {options} = this.props.interaction;
        if (this.props.interaction.options) {
            return options.map(opt => {
                return (
                    <div
                        className='btn center'
                        key={opt._id}
                        onClick={() => this.props.action(opt.value)}>
                        <h4>{opt.text}</h4>
                    </div>
                );
            });
        } else {
            return (
                <div />
            );
        }
    }

    render () {
        return (
            <div className='browser interaction'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                    </div>
                    <header>
                        <img src={MessageIcon} alt='login' />
                        <h2>Central de mensagens</h2>
                    </header>
                    <div className='header'>
                        <div className='row'>
                            <span>De:</span>
                            <span className='rounded-input'>{this.props.interaction.from}</span>
                        </div>
                        <div className='row'>
                            <span>Assunto:</span>
                            <span className='rounded-input'>{this.props.interaction.content.subject}</span>
                        </div>
                    </div>
                </div>
                <div className='content'>
                    <div className='emailCard'>
                        <span>{Text.nl2br(this.props.interaction.content.message)}</span>
                    </div>
                </div>
                <div className='padding'>
                    {this.optionsRenderer()}
                </div>
            </div>
        );
    }
};

export default EmailView;



// WEBPACK FOOTER //
// ./src/views/InteractionViews/emailView.js